import { BillingInformation } from "@/interfaces/billingInformations";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserBillingInformationStore = defineStore(
  "userBillingInformation",
  () => {
    const billingInformation = ref<BillingInformation>();

    return {
      billingInformation,

      setBillingInformation(value: BillingInformation) {
        billingInformation.value = value;
      },
    };
  },
);
